module.exports = "/images/list-icon.svg?929e374684c0053f31a7730fc70b5142";